
// Dev account:
// export const cognitoConfig = {
//     // userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
//     // clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
//     userPoolId: 'us-west-2_gmqURUgxs',
//     clientId: '7f1kt8dalub0idm98ina2s627j',
//     identityPoolId: 'us-west-2:7256369b-1cfe-4cd2-b3b0-e52d2fe0e79b',
//     region: 'us-west-2',
//   };

// Staging account:
export const cognitoConfig = {
  // userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  // clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  userPoolId: process.env.REACT_APP_USER_POOL_ID,//'us-west-2_KtSQKaoYi',
  clientId: process.env.REACT_APP_CLIENT_ID,//'3si039evs4km4046pgg3pujis3',
  identityPoolId: process.env.REACT_APP_ID_POOL_ID,//'us-west-2:67a52b49-3e35-4170-af1e-4e00807e329c',
  region: 'us-west-2',
};

  
  export const cognitoSchoolCode = 'ADM8365'
  export const cognitoSchool = 'Esteam Academy'
  